import { render, staticRenderFns } from "./PostFileItem.vue?vue&type=template&id=503370cc&scoped=true&"
import script from "./PostFileItem.vue?vue&type=script&lang=ts&"
export * from "./PostFileItem.vue?vue&type=script&lang=ts&"
import style0 from "./PostFileItem.vue?vue&type=style&index=0&id=503370cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503370cc",
  null
  
)

export default component.exports